import { reducers } from "@insite/client-framework/Store/Reducers";
import storeReducer, { StoreActions } from "@store/Framework/Store/Store/StoreReducer";
import toolkitReducer, { ToolkitActions } from "@store/Framework/Store/Toolkit/ToolkitReducer";

export type ToolkitAnyAction = ToolkitActions;
(reducers as any).toolkit = toolkitReducer;

export type StoreAnyAction = StoreActions;
(reducers as any).store = storeReducer;
